import { FC } from 'react'
import { useIntl } from 'react-intl'

import { useUsersProfilDeliverAddressAfter } from 'services/profile/profile.hooks'

import UserDetailsAddressForm from './UserDetailsAddressForm'

interface UserDetailsAddressAfterRentalProps {
  onBack: () => void
}

const UserDetailsAddressAfterRental: FC<UserDetailsAddressAfterRentalProps> = ({ onBack }) => {
  const { formatMessage } = useIntl()
  const { usersProfilDeliverAddressAfter, usersProfilDeliverAddressAfterUpdate } =
    useUsersProfilDeliverAddressAfter()

  return (
    <UserDetailsAddressForm
      onBack={onBack}
      title={formatMessage({ id: 'userDetails.addressDuring', defaultMessage: 'Adres do doręczeń' })}
      subtitle={formatMessage({
        id: 'userDetails.addressDuring3',
        defaultMessage: 'Po zakończeniu umowy'
      })}
      address={usersProfilDeliverAddressAfter}
      onSave={(values) => usersProfilDeliverAddressAfterUpdate.mutateAsync(values)}
    />
  )
}

export default UserDetailsAddressAfterRental
